export const Countries = `
Afghanistan
Aland Islands 
Albania 
Algeria
American Samoa,samoa
Andorra 
Angola 
Anguilla
Antarctica 
Antigua and Barbuda 
Argentina 
Armenia
Aruba 
Australia 
Austria 
Azerbaijan
Bahamas 
Bahrain 
Bangladesh 
Barbados
Belarus 
Belgium 
Belize 
Benin
Bermuda 
Bhutan 
Bolivia 
Bonaire, Sint Eustatius and Saba
Bosnia and Herzegovina 
Botswana 
Bouvet Island 
Brazil
British Indian Ocean Territory 
Brunei Darussalam 
Bulgaria 
Burkina Faso
Burundi 
Cambodia 
Cameroon 
Canada 
Cape Verde
Cayman Islands 
Central African Republic 
Chad 
Chile
China 
Christmas Island 
Cocos (Keeling) Islands 
Colombia
Comoros 
Congo 
Congo, the Democratic Republic of the 
Cook Islands
Costa Rica 
Croatia 
Cuba 
Curacao
Cyprus 
Czech Republic 
Denmark 
Djibouti 
Dominica 
Dominican Republic
East Timor 
Ecuador 
Egypt 
El Salvador
England 
Equatorial Guinea 
Eritrea 
Estonia
Eswatini 
Ethiopia 
Falkland Islands 
Faroe Islands 
Fiji 
Finland
France 
French Guiana 
French Polynesia 
French Southern Territories
Gabon 
Gambia 
Georgia 
Germany
Ghana 
Gibraltar 
Greece 
Greenland
Grenada 
Guadeloupe 
Guam 
Guatemala
Guernsey, Alderney, Sark 
Guinea 
Guinea-Bissau 
Guyana
Haiti 
Heard Island and McDonald Islands 
Honduras 
Hong Kong
Hungary 
Iceland 
India 
Indonesia 
Iran
Iraq 
Ireland 
Isle of Man 
Israel
Italy 
Ivory Coast 
Jamaica 
Japan 
Jersey 
Jordan
Kazakhstan 
Kenya 
Kiribati 
Kosovo
Kuwait 
Kyrgyzstan 
Laos 
Latvia 
Lebanon 
Lesotho
Liberia 
Libya 
Liechtenstein 
Lithuania
Luxembourg 
Macao 
Madagascar 
Malawi 
Malaysia
Maldives 
Mali 
Malta 
Marshall Islands
Martinique 
Mauritania 
Mauritius 
Mayotte
Mexico 
Micronesia 
Moldova 
Monaco
Mongolia 
Montenegro 
Montserrat 
Morocco
Mozambique 
Myanmar 
Namibia 
Nauru 
Nepal 
Netherlands
New Caledonia 
New Zealand 
Nicaragua 
Niger
Nigeria 
Niue 
Norfolk Island 
North Korea
North Macedonia 
Northern Ireland 
Northern Mariana Islands 
Norway 
Oman
Pakistan 
Palau 
Palestine
Panama
Papua New Guinea 
Paraguay 
Peru 
Philippines
Pitcairn 
Poland 
Portugal 
Puerto Rico
Qatar
Reunion 
Romania 
Russia 
Rwanda
Saint Barthelemy 
Saint Helena, Ascension and Tristan da Cunha 
Saint Kitts and Nevis 
Saint Lucia
Saint Martin (French part) 
Saint Pierre and Miquelon 
Saint Vincent and the Grenadines 
Samoa
San Marino 
Sao Tome and Principe 
Saudi Arabia 
Scotland
Senegal 
Serbia 
Seychelles 
Sierra Leone
Singapore 
Sint Maarten (Dutch part) 
Slovakia 
Slovenia
Solomon Islands 
Somalia 
South Africa 
South Georgia and the South Sandwich Islands
South Korea 
South Sudan 
Spain 
Sri Lanka
Sudan 
Suriname 
Svalbard and Jan Mayen 
Sweden
Switzerland 
Syria 
Taiwan 
Tajikistan 
Tanzania 
Thailand
Togo 
Tokelau 
Tonga 
Trinidad and Tobago
Tunisia 
Turkey 
Turkmenistan 
Turks and Caicos Islands
Tuvalu 
Uganda 
Ukraine 
United Arab Emirates 
United Kingdom
United States, US, USA, America, U.S., U.S.A.
United States Minor Outlying Islands 
Uruguay 
Uzbekistan
Vanuatu 
Vatican City 
Venezuela 
Vietnam
Virgin Islands, British 
Virgin Islands, U.S. 
Wales 
Wallis and Futuna 
Western Sahara
Yemen
Zambia 
Zimbabwe
`;